import { render, staticRenderFns } from "./ModalBuildingAmount.vue?vue&type=template&id=4029739a"
import script from "./ModalBuildingAmount.vue?vue&type=script&lang=js"
export * from "./ModalBuildingAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports